import React from 'react';
import styles from '../../Home.module.css';

const HowItWorks = () => (
  <section className={styles.sec} id="how">
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.secHeadCenter} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />How it works</span>
        <h2>Get paid in three steps.</h2>
        <p className={styles.secLead}>Send a request, let your customer choose how to pay, and watch the money land. No code required.</p>
      </div>
      <div className={styles.steps}>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>01</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16v16H4z" /><path d="M8 9h8M8 13h5" /><path d="m17 17 3 3" />
            </svg>
          </div>
          <h3>Send an invoice or payment link</h3>
          <p>Create a branded invoice or a payment link in seconds and send it by email, text, or QR.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>02</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="6" width="18" height="13" rx="2" /><path d="M3 10h18M7 15h4" />
            </svg>
          </div>
          <h3>Customer pays, their way</h3>
          <p>They pay with Fyntiq Wallet, card, Apple Pay, Google Pay, Cash App Pay, bank transfer, or financing — whatever&apos;s easiest.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>03</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3v12m0 0-4-4m4 4 4-4M5 21h14" />
            </svg>
          </div>
          <h3>Money lands in your account</h3>
          <p>Payments settle fast — as soon as the same day with Fyntiq Wallet, and about two business days for cards and bank transfers.</p>
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorks;
